import React from 'react';

import { Box } from '@gathertown/uikit-react-native-foundation';

import TypedPlaceholder from '../../../components/TypedPlaceholder';

const MessageSearchStatusEmpty = () => {
  return (
    <Box flex={1} alignItems={'center'} justifyContent={'center'}>
      <TypedPlaceholder type={'no-results-found'} />
    </Box>
  );
};

export default MessageSearchStatusEmpty;
